import { getCache, setCache } from '@/helpers';
import { apiClient, authUrl } from '../http-common';
export function grantAccessToken(payload) {
    return new Promise((resolve, reject) => {
        apiClient.post(`${authUrl}/user/login`, payload).then(response => {
            if (response.status === 200) {
                resolve(response.data);
            }
        }).catch(err => reject(err));
    });
}
export function grantNewAccessToken() {
    return new Promise((resolve, reject) => {
        apiClient.post(`${authUrl}/refresh`).then(response => {
            if (response.status === 200) {
                const cache = getCache();
                cache.access_token = response.data.access_token;
                cache.expires_in = response.data.expires_in;
                setCache(cache);
                resolve(response.data.access_token);
            }
        });
    });
}
export function authenticateUser() {
    return new Promise((resolve, reject) => {
        apiClient.get(`${authUrl}/me`).then(response => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}
export function signOutUser() {
    return new Promise((resolve, reject) => {
        apiClient.post(`${authUrl}/logout`).then(response => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}
export function forgotPassword(payload) {
    return new Promise((resolve, reject) => {
        apiClient.post(`${authUrl}/forgot-password`, payload).then(response => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}
export function resetPassword(payload) {
    return new Promise((resolve, reject) => {
        apiClient.post(`${authUrl}/reset-password`, payload).then(response => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}
